import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Dashcomponent from "../../dashboard/dashcomponent";
import { baseurl } from "../../constant";
const MainWalletTransfer = (props) => {
  const [message, setmessage] = useState();
  const [amount, setamount] = useState();
  const [active, setActive] = useState(1);
  const token = localStorage.getItem("authToken");
  const getdata = async () => {
    const result = await axios.post(baseurl + "walletTransferAuth", {
      token: token,
      amount: amount,

      // fromDate: startdate.replaceAll('/', '-'),
      // fromDate: enddate.replaceAll('/', '-'),
      // keyword: keyword,
      // status: status,
    });

    setmessage(result.data);
  };

  return (
    // <div>
    //   <div>
    //     {message ? <p style={{ color: "red" }}>{message.message}</p> : ""}
    //     <h1>Main Wallet Transfer</h1>
    //     <button>Back</button>
    //   </div>
    //   <table
    //     className="table table-bordered table-striped"
    //     id="newPayoutTransferDataTable"
    //     width="100%"
    //     cellspacing="0"
    //   >
    //     <thead>
    //       <tr>
    //         <th>UPI Wallet Balance</th>
    //         <th>Available Balance</th>

    //         <th>Amount*</th>
    //         <th>Description</th>
    //       </tr>
    //     </thead>
    //     <tfoot>
    //       <tr>
    //         <td>
    //           <input type="text" placeholder={props.upiwallet} />
    //         </td>
    //         <td>
    //           <input type="text" placeholder="0" />
    //         </td>

    //         <td>
    //           <input
    //             type="text"
    //             value={amount}
    //             onChange={(e) => setamount(e.target.value)}
    //           />
    //         </td>
    //         <td>
    //           <input type="text" placeholder="Transfer To Main Wallet" />
    //         </td>
    //       </tr>
    //     </tfoot>
    //     <tbody></tbody>
    //   </table>
    //   <div style={{ marginLeft: "900px" }}>
    //     <button onClick={getdata}>Submit</button>
    //     <button>Cancle</button>
    //   </div>
    // </div>
    <>
      <div>
        <div>
          {message ? <p style={{ color: "red" }}>{message.message}</p> : ""}
        </div>
        <div class="card shadow ">
          <div class="card-header py-3">
            <div class="row">
              <div class="col-sm-6">
                <h4>
                  <b>Main Wallet Transfer</b>
                </h4>
              </div>

              <div class="col-sm-6  text-right">
                {/* <button class="btn btn-primary">
                  <i class="fa fa-arrow-left">Back</i>
                </button> */}
              </div>
            </div>
          </div>
          <div class="card-body">
            <form
              id="admin_profile"
              method="post"
              enctype="multipart/form-data"
              accept-charset="utf-8"
            >
              <input type="hidden" id="siteUrl" />
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>
                      <b>UPI Wallet Balance</b>
                    </label>
                    <input
                      type="text"
                      readonly="readonly"
                      class="form-control"
                      name="upi_wallet_balance"
                      placeholder={props.upiwallet}
                    />
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label>
                      <b>Available Balance</b>
                    </label>
                    <input
                      type="text"
                      readonly="readonly"
                      class="form-control"
                      name="release_amount"
                      value="0"
                      placeholder="UPI Wallet Balance"
                    />
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label>
                      <b>Amount*</b>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="amount"
                      id="amount"
                      placeholder="Amount"
                      value={amount}
                      onChange={(e) => setamount(e.target.value)}
                    />
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="form-group">
                    <label>
                      <b>Description</b>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="description"
                      id="description"
                      placeholder="Description"
                      value="Transfer To Main Wallet"
                      readonly=""
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-header py-3 text-right">
            <button
              type="submit"
              id="submit-btn"
              class="btn btn-success"
              onClick={getdata}
            >
              Submit
            </button>
            {/* <button type="button" class="btn btn-secondary">
              Cancel
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainWalletTransfer;
